import { MessageKey } from 'lightning-messages/lib/messages';
import { ElementType, useEffect, useRef } from 'react';
import { getHtmlCopy, getTextCopy } from '../../i18n';
import { isRunningInJest } from '../../utilities/is-running-in-jest';

const DEFAULT_ELEMENT_TYPE = 'span';

export interface MessageProps {
    className?: string;
    elementType?: ElementType;
    messageKey: MessageKey;
    messageProps?: any;
    textOnly?: boolean;
}

export const Message = ({
    className,
    elementType = DEFAULT_ELEMENT_TYPE,
    messageKey,
    messageProps,
    textOnly,
}: MessageProps) => {
    const Root: ElementType = elementType;
    const messageElem = useRef(null);
    const html = textOnly
        ? getHtmlCopy(messageKey, messageProps)
        : getTextCopy(messageKey, messageProps);

    useEffect(() => {
        // This useEffect is for handling external links.
        // All external links in our copy should use the following anchor attributes:
        // rel="noreferrer" target="_blank"
        // If the attributes are set correctly, then no change actually occurs.
        // Likewise, this code cannot be tested in jest, since it is tied to window.
        const currentWindowHost = window?.location?.hostname;
        if (!isRunningInJest() && messageElem.current && currentWindowHost) {
            const elem = messageElem.current as HTMLObjectElement;
            elem.childNodes.forEach((node) => {
                const anchor = node as HTMLAnchorElement;
                if (
                    anchor &&
                    node.nodeName.toLowerCase() === 'a' &&
                    anchor.href &&
                    anchor.hostname &&
                    anchor.hostname !== currentWindowHost
                ) {
                    anchor.rel = 'noreferrer';
                    anchor.target = '_blank';
                }
            });
        }
    }, [messageElem, messageKey, messageProps]);

    return (
        <Root
            className={className}
            dangerouslySetInnerHTML={{ __html: html }}
            ref={messageElem}
        />
    );
};
